import { FC } from 'react';
import ContactsCompaniesExpanded from './contactsCompaniesExpanded/contactsCompaniesExpandedTable';

const ContactCompaniesExpandedInfo: FC = () => <ContactsCompaniesExpanded />;

export default ContactCompaniesExpandedInfo;
